var waiting_list_button = ( function( $ ) {


	var $button;
	var post_id;
	var list;

	var _init = function() {
		$button = $( '.book-now' );

		if ( $button.hasClass( 'disabled' ) || $button.hasClass( 'logged-out' ) || !$button.hasClass( 'booking-form-link' ) ) {
			return;
		}

		post_id = $button.data( 'id' );
		$button.on( 'click', _call_ajax );
	};

	var _call_ajax = function(e) {
		e.preventDefault();

		$.post( ScriptData.ajaxurl, {
			action: 'crate_is_fully_booked',
			nonce: ScriptData.is_fully_booked_nonce,
			post_id: post_id
		}, _on_success ).fail( ( jqXHR, textStatus, errorThrown ) => _on_failure( errorThrown ) )
	};

	var _on_success = function( response ) {
		if ( response.fully_booked ) {
			var text = 'Sorry, this event is now fully booked.';

			if ( ! $button.hasClass('waiting-list-disabled') ) {
				text += ' Please refresh the page to join the waiting list.';
			}

			var $error_message = $( '.error-message' );
			$error_message.removeClass( 'hidden' );
			$error_message.text( text );
			$button.addClass( "disabled" );

			return;
		}

		window.location.href = $button.attr('href');
	}

	var _on_failure = function( error ) {
		var $error_message = $( '.error-message' );
		$error_message.removeClass( 'hidden' );
		$error_message.text( 'Invalid request. Please refresh and try again.' );
	}

	if ( $( '.book-now' ).length > 0 ) {
		_init();
	}
	return {};

} )( jQuery );

module.exports = waiting_list_button;